webpackJsonp([16],{

/***/ 107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_00_Welcome_vue__ = __webpack_require__(48);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9f106e0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_00_Welcome_vue__ = __webpack_require__(111);
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_00_Welcome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9f106e0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_00_Welcome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background animate__animated animate__fadeIn",staticStyle:{"height":"100vh","overflow":"hidden"}},[_c('header',{staticClass:"py-2 animate__animated animate__fadeIn animate__faster w-full",staticStyle:{"position":"fixed","z-index":"10"}},[_c('div',{staticClass:"flex items-center"},[_c('div',{staticClass:"flex-1 text-right text-white"},[_c('div',{staticClass:"py-2 px-4 bg-transparent text-white inline-block"},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fas fa-medal text-orange-300"}),_vm._v("\n             TU RECORD: "+_vm._s(_vm.record)+"\n          ")])])])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"height":"30vh"}},[_c('div',{staticStyle:{"clear":"both","height":"50%"}}),_vm._v(" "),_c('div',{staticClass:"animate__animated animate__pulse animate__infinite"},[_c('div',{staticStyle:{"transform":"rotate(-5deg)"}},[_c('button',{staticClass:"button is-yellow shadow-md text-blue-500",staticStyle:{"transform":"scale(2.5)"},on:{"click":function($event){return _vm.onPlayClicked()}}},[_vm._v(_vm._s(_vm.$t('home.jugar')))])])])]),_vm._v(" "),(false)?_c('div',{staticClass:"text-center",staticStyle:{"height":"20vh"}},[_c('div',{staticStyle:{"clear":"both","height":"50%"}}),_vm._v(" "),_c('button',{staticClass:"button bg-transparent text-white",on:{"click":function($event){return _vm.onInstructionsClicked()}}},[_vm._v(_vm._s(_vm.$t('home.instrucciones')))])]):_vm._e(),_vm._v(" "),_c('header',{staticClass:"py-4 px-4 animate__animated animate__fadeIn animate__faster w-full text-right text-xs text-blue-400",staticStyle:{"position":"fixed","z-index":"9","bottom":"0","right":"0"}},[_vm._v("\n    v3.7\n  ")]),_vm._v(" "),_c('header',{staticClass:"py-4 px-4 animate__animated animate__fadeIn animate__faster w-full",staticStyle:{"position":"fixed","z-index":"10","bottom":"0"}},[_c('button',{staticClass:"button bg-transparent text-white",on:{"click":function($event){return _vm.onMuteSoundClicked();}}},[(!_vm.muteSound)?_c('i',{staticClass:"fas fa-volume"}):_vm._e(),_vm._v(" "),(_vm.muteSound)?_c('i',{staticClass:"fas fa-volume-slash"}):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"button bg-transparent text-white",on:{"click":function($event){return _vm.onMuteMusicClicked();}}},[(!_vm.muteMusic)?_c('i',{staticClass:"fas fa-music"}):_vm._e(),_vm._v(" "),(_vm.muteMusic)?_c('i',{staticClass:"fas fa-music-slash"}):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center",staticStyle:{"height":"50vh","position":"relative"}},[_c('div',{staticStyle:{"clear":"both","height":"60%"}}),_vm._v(" "),_c('i',{staticClass:"fad fa-calculator text-yellow-100",staticStyle:{"position":"absolute","top":"calc(55% - 60px)","left":"calc(50% - 60px)","font-size":"120px","z-index":"1","opacity":"0.25","transform":"rotate(-15deg)"}}),_vm._v(" "),_c('div',{staticClass:"animate__animated animate__zoomIn animate__fast title",staticStyle:{"position":"relative","z-index":"2"}},[_c('div',{staticStyle:{"font-size":"70px","transform":"rotate(10deg)","text-shadow":"6px 6px 16px rgba(0,0,0,0.3)"}},[_c('b',{staticClass:"text-white"},[_vm._v("CALCUCIL")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_00_Auth_vue__ = __webpack_require__(49);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6b83bba_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_00_Auth_vue__ = __webpack_require__(113);
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_00_Auth_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6b83bba_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_00_Auth_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background animate__animated animate__fadeIn",staticStyle:{"height":"100vh","overflow":"hidden"}},[_c('div',{staticStyle:{"clear":"both","height":"20%"}}),_vm._v(" "),_c('div',{staticClass:"w-full max-w-xs mx-auto"},[_c('form',{staticClass:"bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"},[_c('div',{staticClass:"mb-4"},[_c('label',{staticClass:"block text-gray-700 text-sm font-bold mb-2",attrs:{"for":"username"}},[_vm._v("Username")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],staticClass:"appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline",attrs:{"id":"username","type":"text","placeholder":"Username"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-6"},[_c('label',{staticClass:"block text-gray-700 text-sm font-bold mb-2",attrs:{"for":"password"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline",attrs:{"id":"password","type":"password","placeholder":"******************"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"text-red-500 text-xs italic"},[_vm._v("Please choose a password.")])]),_vm._v(" "),_c('div',{staticClass:"mb-6"},[_c('label',{staticClass:"block text-gray-700 text-sm font-bold mb-2",attrs:{"for":"password"}},[_vm._v("Repeat password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password_repeat),expression:"password_repeat"}],staticClass:"appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline",attrs:{"id":"password","type":"password","placeholder":"******************"},domProps:{"value":(_vm.password_repeat)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password_repeat=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"text-red-500 text-xs italic"},[_vm._v("Please choose a password.")])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"section"},[_vm._v("\n      Crea una cuenta de usuario para recuperar tus puntuaciones si accedes desde otro dispositivo.\n    ")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center justify-center"},[_c('button',{staticClass:"bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline",attrs:{"type":"button"}},[_vm._v("Sign In")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 114:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_01_Instructions_vue__ = __webpack_require__(50);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f3a7f1e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_01_Instructions_vue__ = __webpack_require__(116);
function injectStyle (ssrContext) {
  __webpack_require__(115)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_01_Instructions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f3a7f1e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_01_Instructions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 115:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey-500",staticStyle:{"height":"100vh","overflow-y":"auto"}},[_c('app-header',{on:{"click":function($event){return _vm.onHeaderEmitted()}}},[_vm._v(_vm._s(_vm.$t('instructions.instrucciones')))]),_vm._v(" "),_c('div',{staticClass:"section animate__animated animate__fadeInUp animate__faster"},[_c('div',{staticClass:"section"},[_c('h2',{staticClass:"text-3xl mt-0 mb-2"},[_vm._v(_vm._s(_vm.$t('instructions.ronda-1')))]),_vm._v(" "),_c('p',[_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque at odio posuere, bibendum dui eget, fermentum sapien. Aenean vestibulum non ligula vel condimentum.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Ut non erat eget felis efficitur vulputate ac ut eros. Sed ac felis accumsan, accumsan sapien eget, iaculis mi. Duis dignissim ultricies tristique. Aenean euismod consequat tellus, at accumsan ligula faucibus vel. In hac habitasse platea dictumst. Cras nisl neque, dignissim et aliquet vel, molestie eu nisl. Nulla facilisi. Phasellus sit amet aliquet justo. Vivamus ut ultrices erat. Donec hendrerit blandit magna eget condimentum.\n      ")]),_vm._v(" "),_c('h2',{staticClass:"text-3xl mt-8 mb-2"},[_vm._v(_vm._s(_vm.$t('instructions.ronda-2')))]),_vm._v(" "),_c('p',[_vm._v("\n        Integer sit amet ultrices velit. Pellentesque nec porttitor leo. Phasellus vulputate ligula sit amet neque ornare accumsan. Curabitur molestie suscipit viverra. Donec euismod, metus ac efficitur egestas, turpis mauris malesuada ipsum, in sagittis massa diam ut massa. Fusce a volutpat libero. In aliquam libero quis dapibus bibendum.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Etiam aliquam nulla dolor, nec accumsan lorem bibendum quis. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Donec malesuada auctor ligula consequat commodo. Morbi turpis ligula, pretium et sagittis non, ullamcorper sit amet libero.\n      ")]),_vm._v(" "),_c('h2',{staticClass:"text-3xl mt-8 mb-2"},[_vm._v(_vm._s(_vm.$t('instructions.ronda-3')))]),_vm._v(" "),_c('p',[_vm._v("\n        Cras euismod gravida arcu mollis ultricies. Integer sagittis tristique odio in blandit. Quisque gravida, neque vitae hendrerit porttitor, sem lorem blandit nisi, a pellentesque ligula tellus vel quam. Maecenas tortor diam, aliquam in dui finibus, fermentum tristique nisl. Curabitur porttitor augue vel nulla consequat consectetur.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Sed id metus pharetra arcu condimentum condimentum. Fusce aliquam lacus ac felis faucibus volutpat. Fusce gravida eros eu finibus ullamcorper.\n      ")])]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both","height":"1rem"}}),_vm._v(" "),_c('div',{staticClass:"section"},[_c('button',{staticClass:"button is-blue w-full text-white",on:{"click":function($event){return _vm.onPlayClicked()}}},[_vm._v("\n        Empezar a jugar\n      ")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_02_Play_vue__ = __webpack_require__(51);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe55a65e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_02_Play_vue__ = __webpack_require__(118);
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_02_Play_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe55a65e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_02_Play_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background",staticStyle:{"height":"100vh","width":"100%"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"background animate__animated animate__fadeIn",staticStyle:{"height":"calc(100vh - 50px)","position":"relative"}},[_c('header',{staticClass:"py-2 animate__animated animate__fadeIn animate__faster w-full",staticStyle:{"position":"fixed","z-index":"10"}},[_c('div',{staticClass:"flex items-center"},[_c('div',{staticClass:"text-left"},[_c('button',{staticClass:"button bg-transparent text-white",on:{"click":function($event){return _vm.onBackClicked()}}},[_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"flex-1 text-right text-white"},[_c('div',{staticClass:"py-2 px-4 bg-transparent text-white inline-block"},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fas fa-check text-green-300"}),_vm._v("\n              "+_vm._s(_vm.success)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"py-2 px-4 bg-transparent text-white inline-block"},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fas fa-times text-red-300"}),_vm._v("\n              "+_vm._s(_vm.fails)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"py-2 px-4 bg-transparent text-white inline-block"},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fas fa-stars text-yellow-300"}),_vm._v("\n              "+_vm._s(_vm.score)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"py-2 px-4 bg-transparent text-white inline-block"},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fas fa-medal text-orange-300"}),_vm._v("\n              "+_vm._s(_vm.record)+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both","height":"56px"}}),_vm._v(" "),_c('div',{staticClass:"section"},[_c('div',{staticClass:"text-center mt-12"},[_c('i',{staticClass:"fas fa-stopwatch text-white text-5xl animate__animated animate__pulse animate__infinite"}),_vm._v(" "),_c('div',{staticClass:"m-2 font-bold text-white text-4xl",staticStyle:{"font-family":"monospace"}},[_vm._v("\n          "+_vm._s(_vm.timeLeftSplited[0])+"\n          "),_c('span',{staticStyle:{"opacity":"0.35"}},[_vm._v("."+_vm._s(_vm.timeLeftSplited[1]))])])]),_vm._v(" "),_c('div',{staticClass:"text-center mt-12"},[_c('div',{staticClass:"mt-6 font-bold text-white text-6xl"},[_vm._v("\n          "+_vm._s(_vm.numero1)+" + "+_vm._s(_vm.numero2)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"font-bold text-white text-6xl"},[_vm._v("= "+_vm._s(_vm.resultado))])])]),_vm._v(" "),_c('div',{staticClass:"section text-center",staticStyle:{"position":"absolute","bottom":"0rem","width":"100%"}},[_c('div',{staticClass:"grid gap-2 grid-cols-2"},[_c('div',[_c('button',{staticClass:"button is-large bg-red-200 w-full",on:{"click":function($event){return _vm.onFalseClicked()}}},[_c('i',{staticClass:"fas fa-times text-red-700 text-6xl"})])]),_vm._v(" "),_c('div',[_c('button',{staticClass:"button is-large bg-green-200 w-full",on:{"click":function($event){return _vm.onTrueClicked()}}},[_c('i',{staticClass:"fas fa-check text-green-700 text-6xl"})])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background animate__animated animate__fadeInUpBig border-t border-yellow-500 shadow-xl",staticStyle:{"position":"fixed","bottom":"0px","height":"50px","width":"100%","left":"0px","z-index":"9","overflow":"hidden"}},[_c('div',{staticStyle:{"position":"fixed","bottom":"0px","height":"50px","width":"100%","left":"0px","z-index":"9"}},[_c('ins',{staticClass:"adsbygoogle",staticStyle:{"display":"block"},attrs:{"data-ad-client":"ca-pub-5752844063568531","data-ad-slot":"3403649078","data-ad-format":"auto","data-full-width-responsive":"true"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fas fa-chevron-left"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_03_GameOver_vue__ = __webpack_require__(52);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5354879e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_03_GameOver_vue__ = __webpack_require__(120);
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_03_GameOver_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5354879e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_03_GameOver_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background animate__animated animate__fadeIn",staticStyle:{"height":"100vh","position":"relative"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show['anuncio']),expression:"show['anuncio']"}],staticClass:"background",staticStyle:{"height":"100vh","width":"100%","position":"fixed","top":"0","left":"0","z-index":"9"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"p-3",staticStyle:{"height":"60px","width":"100%","position":"fixed","bottom":"0","left":"0"}},[_c('button',{staticClass:"button is-yellow shadow-md text-blue-500 w-full disabled:opacity-50 disabled:shadow-none",attrs:{"disabled":!!_vm.anuncio_countdown},on:{"click":function($event){return _vm.onCloseAdClicked()}}},[_vm._v("\n        Cerrar anuncio"),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.anuncio_countdown),expression:"anuncio_countdown"}],staticStyle:{"opacity":"0.25"},attrs:{"id":"anuncio_separador"}},[_vm._v(" | ")]),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.anuncio_countdown),expression:"anuncio_countdown"}],staticStyle:{"opacity":"0.5"},attrs:{"id":"anuncio_countdown"}},[_vm._v(_vm._s(_vm.anuncio_countdown))])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"height":"50vh","position":"relative"}},[_c('div',{staticClass:"mx-auto",staticStyle:{"width":"320px"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show['success']),expression:"show['success']"}],staticClass:"animate__animated animate__fast animate__fadeInDown px-4 text-white text-1xl"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"text-right inline-block",staticStyle:{"width":"80px"}},[_c('span',{staticStyle:{"opacity":"0.35"}},[_vm._v("+")]),_vm._v("\n          "+_vm._s(_vm.success)+"\n        ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show['fails']),expression:"show['fails']"}],staticClass:"animate__animated animate__fast animate__fadeInDown px-4 text-white text-1xl"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"text-right inline-block",staticStyle:{"width":"80px"}},[_c('span',{staticStyle:{"opacity":"0.35"}},[_vm._v("-")]),_vm._v("\n          "+_vm._s(_vm.fails)+"\n        ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show['time']),expression:"show['time']"}],staticClass:"animate__animated animate__fast animate__fadeInDown px-4 text-white text-1xl"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"text-right inline-block",staticStyle:{"width":"80px"}},[_c('span',{staticStyle:{"opacity":"0.35"}},[_vm._v("x")]),_vm._v("\n          "+_vm._s(_vm.maxTime)+"\n        ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show['level']),expression:"show['level']"}],staticClass:"animate__animated animate__fast animate__fadeInDown px-4 text-white text-1xl"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"text-right inline-block",staticStyle:{"width":"80px"}},[_c('span',{staticStyle:{"opacity":"0.35"}},[_vm._v("x")]),_vm._v("\n          "+_vm._s(_vm.maxLevel)+"\n        ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show['score']),expression:"show['score']"}],staticClass:"animate__animated animate__fast animate__fadeInDown my-4 py-2 px-4 text-white text-3xl"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"text-right inline-block font-bold",staticStyle:{"width":"80px"}},[_vm._v("\n          "+_vm._s(_vm.score)+"\n        ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show['record']),expression:"show['record']"}],staticClass:"animate__animated animate__fast animate__fadeInDown py-2 px-4 text-white text-1xl"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"text-right inline-block",staticStyle:{"width":"80px"}},[_vm._v("\n          "+_vm._s(_vm.record)+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"section text-center",staticStyle:{"position":"absolute","bottom":"4rem","width":"100%"}},[_c('div',[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.show['retry']),expression:"show['retry']"}],staticClass:"button is-large is-yellow text-blue-500 shadow-lg animate__animated animate__fast animate__bounceIn",on:{"click":function($event){return _vm.onRetryClicked()}}},[_vm._v("\n        Reintentar\n      ")])]),_vm._v(" "),_c('div',{staticClass:"mt-6"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.show['exit']),expression:"show['exit']"}],staticClass:"button bg-transparent text-white text-2xl animate__animated animate__fast animate__fadeIn",on:{"click":function($event){return _vm.onBackClicked()}}},[_vm._v("\n        Salir\n      ")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"calc(100vh - 60px)","width":"100%","position":"fixed","top":"0","left":"0"}},[_c('div',{staticStyle:{"height":"calc(100vh - 60px)","width":"100%"}},[_c('ins',{staticClass:"adsbygoogle",staticStyle:{"display":"block"},attrs:{"data-ad-client":"ca-pub-5752844063568531","data-ad-slot":"6942249464","data-ad-format":"auto","data-full-width-responsive":"true"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center",staticStyle:{"height":"30vh","position":"relative"}},[_c('div',{staticStyle:{"clear":"both","height":"40%"}}),_vm._v(" "),_c('div',{staticClass:"animate__animated animate__pulse animate__faster title",staticStyle:{"position":"relative","z-index":"2"}},[_c('div',{staticStyle:{"font-size":"50px","text-shadow":"6px 6px 16px rgba(0, 0, 0, 0.3)"}},[_c('b',{staticClass:"text-white"},[_vm._v("GAME OVER")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left inline-block",staticStyle:{"width":"200px"}},[_c('i',{staticClass:"fas fa-check text-green-300",staticStyle:{"width":"32px"}}),_vm._v("\n          ACIERTOS\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left inline-block",staticStyle:{"width":"200px"}},[_c('i',{staticClass:"fas fa-times text-red-300",staticStyle:{"width":"32px","position":"relative","left":"2px"}}),_vm._v("\n          FALLOS\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left inline-block",staticStyle:{"width":"200px"}},[_c('i',{staticClass:"fas fa-stopwatch text-purple-300",staticStyle:{"width":"32px"}}),_vm._v("\n          TIEMPO MÁX.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left inline-block",staticStyle:{"width":"200px"}},[_c('i',{staticClass:"fas fa-arrow-circle-up text-teal-300",staticStyle:{"width":"32px"}}),_vm._v("\n          NIVEL MÁX.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left inline-block font-bold",staticStyle:{"width":"200px"}},[_c('i',{staticClass:"fas fa-stars text-yellow-300",staticStyle:{"width":"32px","position":"relative","left":"-6px"}}),_vm._v("\n          PUNTOS\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left inline-block",staticStyle:{"width":"200px"}},[_c('i',{staticClass:"fas fa-medal text-orange-300",staticStyle:{"width":"32px"}}),_vm._v(" TU\n          RECORD\n        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_i18n__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(47);






__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]);

var i18n = new __WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]({
  locale: 'en',
  fallbackLocale: ['en', 'es']
});

var loadedModules = [];

function setI18nLanguage(lang) {
  i18n.locale = lang;
  __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common['Accept-Language'] = lang;
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

function loadModuleAsync(module, lang) {
  // If the module was already loaded
  if (loadedModules.includes(module + '/' + lang)) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(setI18nLanguage(lang));
  }

  // If the module hasn't been loaded yet
  return __webpack_require__(140)("./" + module + '/' + lang + '.json').then(function (messages) {
    var i18nMessages = i18n.messages || {};
    i18nMessages[lang] = i18nMessages[lang] || {};
    i18nMessages[lang][module] = i18nMessages[lang][module] || {};
    i18nMessages[lang][module] = messages;
    i18n.setLocaleMessage(lang, i18nMessages[lang]);
    loadedModules.push(lang);
    return setI18nLanguage(lang);
  }).catch(function () {
    return setI18nLanguage(lang);
  });
}

__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].beforeEach(function (to, from, next) {
  var module = to.path.substr(1).split('/')[0] || 'home';
  var userLang = navigator.language.split('-')[0];
  userLang = /(ca|en|es|fr|it)/gi.test(userLang) ? userLang : 'es';
  loadModuleAsync(module, userLang).then(function () {
    return next();
  });
});

/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./home/ca.json": [
		171,
		14
	],
	"./home/en.json": [
		172,
		13
	],
	"./home/es.json": [
		173,
		12
	],
	"./home/fr.json": [
		174,
		11
	],
	"./home/it.json": [
		175,
		10
	],
	"./init/ca.json": [
		176,
		9
	],
	"./init/en.json": [
		177,
		8
	],
	"./init/es.json": [
		178,
		7
	],
	"./init/fr.json": [
		179,
		6
	],
	"./init/it.json": [
		180,
		5
	],
	"./instructions/ca.json": [
		181,
		4
	],
	"./instructions/en.json": [
		182,
		3
	],
	"./instructions/es.json": [
		183,
		2
	],
	"./instructions/fr.json": [
		184,
		1
	],
	"./instructions/it.json": [
		185,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 140;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./app-header.vue": 169
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 168;

/***/ }),

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__ = __webpack_require__(63);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e8ca466_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__ = __webpack_require__(170);
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e8ca466_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"bg-blue-500 py-2 animate__animated animate__fadeInDown animate__faster w-full shadow",staticStyle:{"position":"fixed","z-index":"10"}},[_c('div',{staticClass:"flex items-center"},[_c('div',{staticClass:"text-left"},[_c('button',{staticClass:"button bg-transparent text-white",on:{"click":function($event){return _vm.onBackClicked()}}},[_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"flex-1 text-left text-white"},[_vm._t("default")],2)])]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both","height":"56px"}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fal fa-chevron-left"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);



//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  created: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var data, settings, base, tools, device;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              data = JSON.parse(localStorage.getItem("calcucil-data") || "{}");
              settings = JSON.parse(localStorage.getItem("calcucil-settings") || "{}");
              base = "/calcucil/play/";


              this.muteSound = settings.muteSound || false;
              this.muteMusic = settings.muteMusic || false;

              _context.next = 7;
              return this.cargarTools();

            case 7:
              tools = window.tools;

              console.log("device cargando");
              _context.next = 11;
              return tools.addJS(base + "static/libs/device/device.js");

            case 11:
              console.log("device cargado");
              device = window.device;
              _context.next = 15;
              return device.ready();

            case 15:
              if (!(device.get("platform") === "browser")) {
                _context.next = 21;
                break;
              }

              if (true) {
                _context.next = 19;
                break;
              }

              window.location = "https://games.almacil.com/calcucil";
              return _context.abrupt("return", false);

            case 19:
              _context.next = 23;
              break;

            case 21:
              this.processAdMob();
              this.processEvents();

            case 23:

              window.introMusic = window.introMusic || new Audio(base + "static/sounds/intro.mp3");

              window.introMusic.loop = true;
              if (!this.muteMusic) {
                window.introMusic.play();
              }

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    cargarTools: function cargarTools() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, _) {
        var base = "/calcucil/play/";
        var script = window.document.createElement("script");
        script.src = base + "static/libs/tools/tools.js";
        script.type = "text/javascript";
        if (script.readyState) {
          // IE
          script.onreadystatechange = function () {
            if (script.readyState === "loaded" || script.readyState === "complete") {
              script.onreadystatechange = null;
              resolve(true);
            }
          };
        } else {
          // Others
          script.onload = function () {
            resolve(true);
          };
        }
        window.document.getElementsByTagName("head")[0].appendChild(script);
      });
    },
    processAdMob: function processAdMob() {
      var device = window.device;
      var platform = device.get("platform");
      var adIds = window.adIds = {
        ios: {
          banner: "ca-app-pub-5162375150967923/6611812751",
          interstitial: "ca-app-pub-5162375150967923/8077895526"
        },
        android: {
          banner: "ca-app-pub-5162375150967923/1786560164", // "ca-app-pub-3940256099942544/6300978111",
          interstitial: "ca-app-pub-5162375150967923/6402137184", // "ca-app-pub-3940256099942544/1033173712",
          reward: "ca-app-pub-5162375150967923/3968037111"
        }
      };
      // IDFA o ID de publicidad SM10: 46395f84-a08e-4547-ab00-2716b88b7dee
      // ID APP Google Pruebas: ca-app-pub-3940256099942544~3347511713

      device.addListener("admob", function (message) {
        if (!message) {
          return;
        }

        if (message.action === "createBanner") {
          if (message.success) {
            // device.postMessage("admob", { action: "showBanner", options: 8 });
          }
        }

        if (message.action === "isInterstitialReady") {
          if (message.response) {
            // device.postMessage("admob", { action: "showInterstitialAd" });
          }
        }
      });

      device.postMessage("nativeBody", {
        html: "\n        <div style=\"padding:1rem;\">\n          Calcucil es un juego de c\xE1lculo mental en el que tienes que indicar si la operaci\xF3n matem\xE1tica que aparece en pantalla es correcta o incorrecta.\n          \n          Sumar\xE1s puntos y tiempo con cada acierto y restar\xE1s puntos con cada fallo.\n          \n          Cuando consigues m\xE1s tiempo y aciertos subir\xE1s de nivel y las operaciones matem\xE1ticas ser\xE1n m\xE1s complejas pero tambi\xE9n ganar\xE1s m\xE1s puntos.\n        </div>\n        "
      });
      device.postMessage("admob", { action: "events" });
      device.postMessage("admob", {
        action: "setOptions",
        options: {
          autoShow: true,
          isTesting: false,
          bgColor: "black",
          overlap: true
        }
      });
      device.postMessage("admob", {
        action: "createBanner",
        options: {
          adId: adIds[platform].banner,
          autoShow: true,
          isTesting: false,
          overlap: true
        }
      });
    },
    processEvents: function processEvents() {
      var _this = this;

      var device = window.device;
      device.addListener("pause", function () {
        if (!_this.muteMusic) {
          window.introMusic.pause();
        }
      });
      device.addListener("resume", function () {
        if (!_this.muteMusic) {
          window.introMusic.play();
        }
      });
    }
  }
});

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_00_Welcome__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_00_Auth__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_01_Instructions__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_02_Play__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_03_GameOver__ = __webpack_require__(119);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  base: '/calcucil/play/',
  routes: [{
    path: '/',
    name: 'Welcome',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_00_Welcome__["a" /* default */]
  }, {
    path: '/auth',
    name: 'Auth',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_00_Auth__["a" /* default */]
  }, {
    path: '/instructions',
    name: 'Instructions',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_01_Instructions__["a" /* default */]
  }, {
    path: '/playing',
    name: 'Play',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_02_Play__["a" /* default */]
  }, {
    path: '/game-over',
    name: 'GameOver',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_03_GameOver__["a" /* default */]
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app-welcome",
  data: function data() {
    return {
      record: 0,
      muteSound: false,
      muteMusic: false
    };
  },

  mounted: function mounted() {},
  created: function created() {
    var data = JSON.parse(localStorage.getItem("calcucil-data") || "{}");
    var settings = JSON.parse(localStorage.getItem("calcucil-settings") || "{}");

    this.muteSound = settings.muteSound || false;
    this.muteMusic = settings.muteMusic || false;

    this.record = data.record || 0;
  },
  methods: {
    onPlayClicked: function onPlayClicked() {
      this.$router.push("playing");
    },
    onInstructionsClicked: function onInstructionsClicked() {
      this.$router.push("instructions");
    },
    onMuteSoundClicked: function onMuteSoundClicked() {
      var settings = JSON.parse(localStorage.getItem("calcucil-settings") || "{}");
      settings.muteSound = !settings.muteSound;
      this.muteSound = settings.muteSound || false;
      localStorage.setItem("calcucil-settings", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(settings));
    },
    onMuteMusicClicked: function onMuteMusicClicked() {
      var settings = JSON.parse(localStorage.getItem("calcucil-settings") || "{}");
      settings.muteMusic = !settings.muteMusic;
      this.muteMusic = settings.muteMusic || false;
      localStorage.setItem("calcucil-settings", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(settings));

      if (this.muteMusic) {
        window.introMusic.pause();
        window.introMusic.currentTime = 0;
      } else {
        window.introMusic.play();
      }
    }
  }
});

/***/ }),

/***/ 49:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app-auth",
  mounted: function mounted() {},
  created: function created() {},
  methods: {
    onPlayClicked: function onPlayClicked() {
      this.$router.push("playing");
    },
    onInstructionsClicked: function onInstructionsClicked() {
      this.$router.push("instructions");
    }
  }
});

/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app-instructions",
  data: function data() {
    return {
      msg: "Rules to Your Vue.js PWA"
    };
  },

  methods: {
    onHeaderEmitted: function onHeaderEmitted() {
      this.$router.replace("/");
    },
    onPlayClicked: function onPlayClicked() {
      this.$router.push("playing");
    }
  }
});

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app-init",
  data: function data() {
    return {
      timeInit: 0,
      timeLimit: 2000,
      timeLeft: 2000,
      timeLeftSplited: [0, 0],
      maxTime: 0,
      maxLevel: 0,
      coins: 0,
      record: 0,
      success: 0,
      fails: 0,
      interval: null,
      numero1: 0,
      numero2: 0,
      resultado: 0,
      playingSound: null,
      tapSound: null,
      errorSound: null,
      gameOverSound: null,
      muteSound: false,
      show: []
    };
  },

  created: function created() {
    this.startGame();
  },
  destroyed: function destroyed() {
    clearInterval(this.interval);
    this.playingSound.pause();
    this.playingSound.currentTime = 0;
  },
  methods: {
    startGame: function startGame() {
      var settings = JSON.parse(localStorage.getItem("calcucil-settings") || "{}");
      this.muteSound = settings.muteSound || false;

      var data = JSON.parse(localStorage.getItem("calcucil-data") || "{}");
      this.success = 0;
      this.fails = 0;
      this.record = data.record || 0;
      this.timeInit = new Date().getTime();
      this.timeLimit = 2000;
      this.timeLeft = 2000;
      this.maxTime = 0;
      this.show = [];

      var base = "/calcucil/play/";

      window.introMusic = window.introMusic || new Audio(base + "static/sounds/intro.mp3");

      window.introMusic.pause();
      window.introMusic.currentTime = 0;

      this.playingSound = this.playingSound || new Audio(base + "static/sounds/playing.mp3");
      this.tapSound = this.tapSound || new Audio(base + "static/sounds/tap.mp3");
      this.errorSound = this.errorSound || new Audio(base + "static/sounds/error.mp3");
      this.gameOverSound = this.gameOverSound || new Audio(base + "static/sounds/game-over.mp3");

      setTimeout(function () {
        (adsbygoogle = window.adsbygoogle || []).push({});
      }, 300);

      // this.playingSound.volume = 0.5;
      // this.playingSound.loop = true;
      // this.playingSound.play();

      clearInterval(this.interval);
      this.interval = setInterval(this.updateTime, 50);
      this.getOperation();
    },
    updateTime: function updateTime() {
      var restante = (new Date().getTime() - this.timeLimit - this.timeInit) / 1000 * -1;
      if (restante < 0) {
        restante = 0;
      }
      var rojo = parseInt(240 - restante / 2 * 100);
      if (rojo < 0) {
        rojo = 0;
      }
      if (rojo > 240) {
        rojo = 240;
      }
      var verde = parseInt(restante / 2 * 100);
      if (verde < 0) {
        verde = 0;
      }
      if (verde > 240) {
        verde = 240;
      }

      this.timeLeft = restante;
      if (parseInt(this.timeLeft) > this.maxTime) {
        this.maxTime = this.timeLeft;
      }
      this.timeLeftSplited = this.timeLeft.toString().split(".");
      this.timeLeftSplited[1] = (this.timeLeftSplited[1] || "0").padStart(3, "0");

      if (restante === 0) {
        clearInterval(this.interval);
        this.gameOver();
      }
    },
    getOperation: function getOperation() {
      var restante = (new Date().getTime() - this.timeLimit - this.timeInit) / 1000 * -1;
      if (restante < 2) {
        restante = 2;
      }
      var dificultad = parseInt(restante) * 5;
      dificultad = parseInt(this.success);
      if (dificultad < 10) {
        dificultad = 10;
      }
      if (dificultad > this.maxLevel) {
        this.maxLevel = dificultad;
      }
      var numero1 = Math.floor(Math.random() * dificultad + 1);
      var numero2 = Math.floor(Math.random() * dificultad + 1);
      var resultado = parseInt(numero1) + parseInt(numero2);
      if (Math.floor(Math.random() * 100) < 50) {
        resultado = numero1 + numero2;
      } else {
        resultado = Math.floor(Math.random() * (parseInt(resultado) + 5) + (parseInt(resultado) - 5 < 1 ? 1 : parseInt(resultado) - 5));
      }
      this.numero1 = numero1;
      this.numero2 = numero2;
      this.resultado = resultado;
      this.score = parseInt((this.success - this.fails) * parseInt(this.maxTime) * parseInt(this.maxLevel / 10));
    },
    addSuccess: function addSuccess() {
      if (!this.muteSound) {
        this.tapSound.play();
      }
      this.success = parseInt(this.success) + 1;
      this.timeLimit += 1500;
      this.getOperation();
    },
    addFail: function addFail() {
      if (!this.muteSound) {
        this.errorSound.play();
      }
      device.postMessage("vibrate", [300]);
      this.fails = parseInt(this.fails) + 1;
      this.timeLimit -= 500;
      this.getOperation();
    },
    gameOver: function gameOver() {
      this.playingSound.pause();
      var dateSaved = JSON.parse(localStorage.getItem("calcucil-data") || "{}");
      var data = {
        comesFromPlaying: true,
        coins: this.coins,
        record: this.record,
        success: this.success,
        fails: this.fails,
        lastAdTime: dateSaved.lastAdTime,
        maxTime: parseInt(this.maxTime),
        maxLevel: parseInt(this.maxLevel / 10)
      };
      localStorage.setItem("calcucil-data", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      this.$router.replace("game-over");
    },
    onTrueClicked: function onTrueClicked() {
      if (this.numero1 + this.numero2 === this.resultado) {
        this.addSuccess();
      } else {
        this.addFail();
      }
    },
    onFalseClicked: function onFalseClicked() {
      if (this.numero1 + this.numero2 !== this.resultado) {
        this.addSuccess();
      } else {
        this.addFail();
      }
    },
    onRetryClicked: function onRetryClicked() {
      this.startGame();
    },
    onBackClicked: function onBackClicked() {
      this.$router.replace("/");
    },
    onContinueClicked: function onContinueClicked() {
      this.$router.push("turno");
    }
  }
});

/***/ }),

/***/ 52:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app-gameover",
  data: function data() {
    return {
      anuncio_countdown: 0,
      coins: 0,
      record: 0,
      success: 0,
      fails: 0,
      maxTime: 0,
      maxLevel: 0,
      score: 0,
      gameOverSound: null,
      muteSound: false,
      muteMusic: false,
      show: []
    };
  },

  created: function created() {
    this.gameOver();
  },
  methods: {
    gameOver: function gameOver() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var settings, data, base, ahora;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                settings = JSON.parse(localStorage.getItem("calcucil-settings") || "{}");

                _this.muteSound = settings.muteSound || false;
                _this.muteMusic = settings.muteMusic || false;

                data = JSON.parse(localStorage.getItem("calcucil-data") || "{}");

                if (data.comesFromPlaying) {
                  _context.next = 7;
                  break;
                }

                _this.$router.replace("/");
                return _context.abrupt("return");

              case 7:
                delete data.comesFromPlaying;
                _this.success = data.success || 0;
                _this.fails = data.fails || 0;
                _this.record = data.record || 0;
                _this.coins = data.coins || 0;
                _this.maxTime = data.maxTime || 0;
                _this.maxLevel = data.maxLevel || 0;
                _this.show = [];

                _this.score = (_this.success - _this.fails) * _this.maxTime * _this.maxLevel;
                if (parseInt(_this.score) > parseInt(_this.record)) {
                  data.record = _this.record = _this.score;
                }
                localStorage.setItem("calcucil-data", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data));

                base = "/calcucil/play/";


                window.introMusic = window.introMusic || new Audio(base + "static/sounds/intro.mp3");

                _this.gameOverSound = _this.gameOverSound || new Audio(base + "static/sounds/game-over.mp3");

                if (!_this.muteSound) {
                  _this.gameOverSound.play();
                }
                console.log('data.lastAdTime', data.lastAdTime);
                data.lastAdTime = data.lastAdTime || 0;
                ahora = Math.round(new Date().getTime() / 1000);

                console.log(ahora, ahora - 60, data.lastAdTime);
                if (false) {
                  _this.show["anuncio"] = false;
                  _this.showResults();
                } else {
                  data.lastAdTime = ahora;console.log(data);
                  localStorage.setItem("calcucil-data", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data));
                  console.log(localStorage.getItem("calcucil-data"));
                  _this.showAd();
                }

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    showResults: function showResults() {
      var _this2 = this;

      setTimeout(function () {
        _this2.show["success"] = true;
        _this2.$forceUpdate();
      }, 200);
      setTimeout(function () {
        _this2.show["fails"] = true;
        _this2.$forceUpdate();
      }, 400);
      setTimeout(function () {
        _this2.show["time"] = true;
        _this2.$forceUpdate();
      }, 600);
      setTimeout(function () {
        _this2.show["level"] = true;
        _this2.$forceUpdate();
      }, 800);
      setTimeout(function () {
        _this2.show["score"] = true;
        _this2.$forceUpdate();
      }, 1000);
      setTimeout(function () {
        _this2.show["record"] = true;
        _this2.$forceUpdate();
      }, 1200);
      setTimeout(function () {
        _this2.show["exit"] = true;
        _this2.$forceUpdate();
      }, 1500);
      setTimeout(function () {
        _this2.show["retry"] = true;
        if (!_this2.muteMusic) {
          window.introMusic.loop = true;
          window.introMusic.play();
        }
        _this2.$forceUpdate();
      }, 1600);
    },
    showAd: function showAd() {
      this.show["anuncio"] = true;
      this.anuncio_countdown = 10;
      this.countdown(this.anuncio_countdown);
      setTimeout(function () {
        (adsbygoogle = window.adsbygoogle || []).push({});
      }, 100);
    },
    countdown: function countdown(segs) {
      var _this3 = this;

      setTimeout(function () {
        _this3.anuncio_countdown = segs - 1;
        if (_this3.anuncio_countdown) {
          _this3.countdown(_this3.anuncio_countdown);
        }
      }, 1000);
    },
    onCloseAdClicked: function onCloseAdClicked() {
      this.show["anuncio"] = false;
      this.showResults();
    },
    showInterstitial: function showInterstitial() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, _) {
        var device = window.device;
        var platform = device.get("platform");
        var adIds = window.adIds;

        if (platform !== "browser") {
          device.postMessage("vibrate", [600]);
          /*device.addListener("admob", (message) => {
            if (message) {
              if ([
                  'onAdDismiss',
                  'onAdFailedToLoad',
                  'onAdFailLoad',
                  'onAdFailed'
                ].includes(message.type)) {
                  resolve();
              }
            }
           }, 'game-over');
          device.postMessage("admob", {
            action: "prepareInterstitial",
            options: {
              adId: adIds[platform].interstitial,
              isTesting: false,
              autoShow: true,
            },
          });*/
        } else {
          resolve();
        }
      });
    },
    onRetryClicked: function onRetryClicked() {
      this.$router.push("playing");
    },
    onBackClicked: function onBackClicked() {
      this.$router.replace("/");
    }
  }
});

/***/ }),

/***/ 63:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app-header",
  methods: {
    onBackClicked: function onBackClicked() {
      this.$emit("click");
    }
  }
});

/***/ }),

/***/ 64:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_upperFirst__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_upperFirst___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_upperFirst__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_camelCase__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_camelCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_camelCase__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







var requireComponent = __webpack_require__(168);

requireComponent.keys().forEach(function (fileName) {
  // Obtener la configuración de los componentes
  var componentConfig = requireComponent(fileName);

  // Obtener el nombre PascalCase del componente
  var componentName = __WEBPACK_IMPORTED_MODULE_4_lodash_upperFirst___default()(__WEBPACK_IMPORTED_MODULE_5_lodash_camelCase___default()(
  // Quitar el `./`en el comienzo y la extensión del nombre del archivo
  fileName.replace(/^\.\/(.*)\.\w+$/, '$1')));

  // Registrar el componente a nivel global
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component(componentName,
  // Busca las opciones de componentes en `.default`, que
  // existen si el componente fue exportado con `export default`,
  // de lo contrario volver a la raíz del módulo.
  componentConfig.default || componentConfig);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */],
  template: '<App/>',
  introMusic: null,
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 67:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(31);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39c59a22_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(107);
function injectStyle (ssrContext) {
  __webpack_require__(68)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39c59a22_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 68:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[64]);


// WEBPACK FOOTER //
// static/js/app.91a5661386bcd63bcc2d.js